<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    name: {
      required: true,
      type: String,
    },
    selected: {
      default: false,
      type: Boolean,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    isActive: false,
  }),
  computed: {
    // Generate the href of the tab based on the id
    href() {
      return '#' + this.id.toLowerCase();
    },
  },
};
</script>
